import { autoinject, bindable } from 'aurelia-framework';
import { OrderItemDTOStatus } from '../../service/api/aok-rest-api';
import { OrderViewModel } from '../../view-models/order-view-model';

@autoinject()
export class Accordion {

    @bindable orders: OrderViewModel[];
}